import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Person} from "../../../services/interface/query/person";
import {useFindDebtsMunicipality} from "../../../services/apis/apiDebts";
import NotPermissionComponent from "../NotPermissionComponent";
import CustomTable, {TypeItemTable} from "../../../components/general/CustomTable";
import {MunicipalityInterface} from "../../../services/interface/query/debs/municipality-interface";
import {getMessageGeneric} from "../../../services/configuration/errorHandle";
import {formatDateHoursString} from "../../../utils/daysOptions";
import InfoOnline from "../../components/InfoOnline";

interface Props {
    person?: Person;
}
export default function Municipality({person}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findDebts,
        data: successDebts,
        error: errorDebts,
        isPending: loadingDebts,
    } = useFindDebtsMunicipality()

    const [response, setResponse] = useState<MunicipalityInterface[] | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()

    useEffect(() => {
        if (person?.identification) {
            findDebts({identifier: person?.identification, msj: t('debts-municipality')})
        }
    }, []);

    useEffect(() => {
        if (successDebts) {
            setResponse(successDebts)
        }
    }, [successDebts]);

    useEffect(() => {
        if (response && response.length > 0) {
            setListElement(response.map(item => ({
                row: [
                    item.debt,
                    item.value,
                    item.status,
                    formatDateHoursString(item.dateUpdate)
                ]
            })))
        }
    }, [response]);

    return (
        <div className={'flex flex-col gap-3'}>
            <div className={'flex flex-row gap-2'}>
                <h3>{t('debts-municipality')}</h3>
                <InfoOnline
                    onClick={() => {
                        if (person?.identification) {
                            findDebts({identifier: person?.identification, msj: t('debts-municipality')})
                        }
                    }}
                />
            </div>
            <NotPermissionComponent
                title={'/debts/municipality'}
                loading={loadingDebts}
                error={errorDebts}
                component={
                    <>
                        <CustomTable
                            loading={loadingDebts}
                            error={getMessageGeneric(errorDebts, '/debts/municipality')}
                            header={[
                                t('debt'),
                                t('value'),
                                t('status'),
                                t('date-update'),
                            ]}
                            {...{listElement}}
                        />
                    </>
                }
            />
        </div>
    )
}
